import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { BRAND_IMG } from "../data/site";

const PRODUCTS = [
  {
    img: BRAND_IMG.doorFrames,
    alt: "MODORS galvanized steel door frames — single and double",
    tag: "Product 01",
    title: "Galvanized Steel Door Frames",
    desc: "Pressed steel door frames in two series — PRIME (5.5\u2033\u00D72.5\u2033) and ECO (5.5\u2033\u00D72\u2033). Single and double door configurations.",
    chips: ["PRIME", "ECO"],
  },
  {
    img: BRAND_IMG.windowFrames,
    alt: "MODORS galvanized steel window frames",
    tag: "Product 02",
    title: "Steel Window Frames",
    desc: "Precision-fabricated galvanized steel window frames in multiple sizes and designs for residential and commercial work.",
    chips: ["GALVANIZED", "PRECISION FABRICATED", "MULTIPLE SIZES"],
  },
];

export const ProductsPreview = () => (
  <section id="products" data-testid="products-preview-section" className="bg-brand-mist py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <SectionHeading
          kicker="Our Products"
          title="Frames Engineered for Every Opening"
        />
        <Reveal delay={0.1}>
          <Link
            to="/products"
            data-testid="products-view-all-btn"
            className="group inline-flex items-center gap-2 text-sm font-semibold tracking-[0.14em] uppercase text-brand-ink hover:text-brand-red transition-colors duration-300"
          >
            All Products
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </Reveal>
      </div>
      <div className="mt-14 grid lg:grid-cols-2 gap-6">
        {PRODUCTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.12}>
            <Link
              to="/products"
              data-testid={`product-card-${i}`}
              className="group block bg-white border border-black/10 hover:border-brand-red transition-colors duration-300"
            >
              <div className="relative h-64 sm:h-80 flex items-center justify-center overflow-hidden bg-white p-8">
                <div className="absolute inset-0 noise-overlay opacity-[0.04]" />
                <img
                  src={p.img}
                  alt={p.alt}
                  className="relative max-h-full w-auto object-contain drop-shadow-[0_18px_28px_rgba(0,0,0,0.18)] transition-transform duration-500 group-hover:scale-[1.04]"
                />
              </div>
              <div className="p-7 sm:p-8 border-t border-black/10">
                <div className="text-[11px] font-semibold tracking-[0.28em] uppercase text-brand-red">{p.tag}</div>
                <h3 className="mt-2 font-display text-2xl font-semibold uppercase tracking-tight text-brand-ink">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm text-brand-ink/55 leading-relaxed">{p.desc}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {p.chips.map((c) => (
                    <span key={c} className="text-[10px] font-semibold tracking-[0.2em] uppercase border border-black/15 px-3 py-1.5 text-brand-ink/60">
                      {c}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
